var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_c('div',[_c('kit-table-8')],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kit__utils__heading"},[_c('h5',[_vm._v("Pricing Tables")])])}]

export { render, staticRenderFns }